import { ContentUnsubscribeModel } from '@/domain/models/content/enrollment/unsubscribe/content-unsubscribe-model'

export interface ContentUnsubscribe {
  getUnsubscribeData(id: string): Promise<ContentUnsubscribeModel>
}

export namespace ContentUnsubscribe {
  export type Model = ContentUnsubscribeModel
  export const key = 'content-unsubscribe'
}
